import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_DEPRECATED_insert_ultraship_inbound_shipment_to_stagingService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { inboundShipmentPayload?: string[], inboundShipmentNumber?: string }): Promise<void> 
  {
    let url = `${environment.backendUrl}api/Ultraship/functions/DEPRECATED_insert_ultraship_inbound_shipment_to_staging`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

